<template>
	<v-stepper :value="step">
		<v-stepper-header>
			<v-stepper-step :complete="step > 1" step="1">Patient Information</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="step > 2" step="2">Appointment</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="step > 3" step="3">Medical Information</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="step > 4" step="4">Grading</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="step > 5" step="5">Result</v-stepper-step>
		</v-stepper-header>
	</v-stepper>
</template>

<script>
export default {
	props: {
		step: {
			type: String,
			required: true
		}
	}
};
</script>